import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import sanitizeSku from "DreamCast/Shared/sanitizeSku";
import styles from "./ThumbnailDetailsForm.module.css";

export const ALL_DETAIL_FIELDS = [
  "title",
  "creatorSpeaker",
  "topic",
  "sku",
  "naCrNumber",
  "anzCrNumber",
];

export function ThumbnailDetailsForm({
  title,
  creatorSpeaker,
  topic,
  sku,
  naCrNumber,
  anzCrNumber,
  onChange,
  className,
  fields,
  readOnlyFields,
  readOnlyHint,
}) {
  const shows = (field) => fields.includes(field);
  const isReadOnly = (field) => readOnlyFields.includes(field);
  const handleChange = (field, value) => {
    onChange({
      title,
      creatorSpeaker,
      topic,
      sku,
      naCrNumber,
      anzCrNumber,
      [field]: value,
    });
  };

  return (
    <section className={classNames(styles.card, className)}>
      <div className={styles.rowHeader}>
        <h3 className={styles.sectionTitle}>Details</h3>
        <div className={styles.divider} />
      </div>

      <div className={styles.fields}>
        {shows("title") && (
          <label className={styles.field}>
            <span className={styles.label}>Title</span>
            <input
              type="text"
              placeholder="Title"
              value={title}
              onChange={(event) => handleChange("title", event.target.value)}
              className={styles.input}
              readOnly={isReadOnly("title")}
            />
          </label>
        )}

        {shows("creatorSpeaker") && (
          <label className={styles.field}>
            <span className={styles.label}>Creator/Speaker</span>
            <input
              type="text"
              placeholder="Creator/Speaker"
              value={creatorSpeaker}
              onChange={(event) =>
                handleChange("creatorSpeaker", event.target.value)
              }
              className={styles.input}
              readOnly={isReadOnly("creatorSpeaker")}
            />
          </label>
        )}

        {shows("topic") && (
          <label className={styles.field}>
            <span className={styles.label}>Topic</span>
            <input
              type="text"
              placeholder="Topic"
              value={topic}
              onChange={(event) => handleChange("topic", event.target.value)}
              className={styles.input}
              readOnly={isReadOnly("topic")}
            />
          </label>
        )}

        {shows("sku") && (
          <label className={styles.field}>
            <span className={styles.label}>SKU</span>
            <input
              type="text"
              placeholder="SKU"
              value={sku}
              onChange={(event) =>
                handleChange("sku", sanitizeSku(event.target.value))
              }
              className={styles.input}
              readOnly={isReadOnly("sku")}
            />
          </label>
        )}

        {shows("naCrNumber") && (
          <label className={styles.field}>
            <span className={styles.label}>NA CR Number</span>
            <input
              type="text"
              placeholder="NA CR Number"
              value={naCrNumber}
              onChange={(event) => handleChange("naCrNumber", event.target.value)}
              className={styles.input}
              readOnly={isReadOnly("naCrNumber")}
            />
          </label>
        )}

        {shows("anzCrNumber") && (
          <label className={styles.field}>
            <span className={styles.label}>ANZ CR Number</span>
            <input
              type="text"
              placeholder="ANZ CR Number"
              value={anzCrNumber}
              onChange={(event) =>
                handleChange("anzCrNumber", event.target.value)
              }
              className={styles.input}
              readOnly={isReadOnly("anzCrNumber")}
            />
          </label>
        )}
        {readOnlyHint && <p className={styles.hint}>{readOnlyHint}</p>}
      </div>
    </section>
  );
}

ThumbnailDetailsForm.propTypes = {
  title: PropTypes.string,
  creatorSpeaker: PropTypes.string,
  topic: PropTypes.string,
  sku: PropTypes.string,
  naCrNumber: PropTypes.string,
  anzCrNumber: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.oneOf(ALL_DETAIL_FIELDS)),
  readOnlyFields: PropTypes.arrayOf(PropTypes.oneOf(ALL_DETAIL_FIELDS)),
  readOnlyHint: PropTypes.string,
};

ThumbnailDetailsForm.defaultProps = {
  title: "",
  creatorSpeaker: "",
  topic: "",
  sku: "",
  naCrNumber: "",
  anzCrNumber: "",
  onChange: () => {},
  className: undefined,
  fields: ALL_DETAIL_FIELDS,
  readOnlyFields: [],
  readOnlyHint: "",
};

export default ThumbnailDetailsForm;
